import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  VertAlert,
  VertButton,
  VertCheckbox,
  VertModal,
} from '@vertem-core/vertice-ds';
import 'Assets/styles/default/components/RatingProducts/RatingProducts.less';
import RatingProduct from './RatingProduct';
import RatingForm from './RatingForm';
import { useRating } from './Provider';
import { StarOutlined, CloseOutlined } from '@ant-design/icons';
import ModalConfirmRating from 'components/Modal/ModalConfirmRating';

const RatingProducts = ({ items, open, onClose }) => {
  const [receivedProduct, setReceivedProduct] = useState(undefined);
  const [modalConfirmation, setModalConfirmation] = useState(false);
  const { myRating } = useRating();
  const [page, setPage] = useState(1);
  const { getRatingByProfile } = useRating();
  const [list, setList] = useState([]);
  if (items && items.length === 0) return (<span />);

  const compareRatingsSkus = useCallback(() => {
    if (!myRating.length) {
      setList(items);
    } else {
      const skus = myRating.map(({ productSku }) => productSku);
      const filteredList = items.filter(({ productSku: sku }) => !skus.includes(sku));
      setList(filteredList);
    }
  }, [myRating, items]);

  useEffect(() => {
    if (myRating) {
      compareRatingsSkus();
    }
  }, [myRating, compareRatingsSkus]);

  const Title = () => {
    return (
      <div className='title-container'>
        <div>
          <StarOutlined className='title-icon' />
          <span className='title-text'> Avalie o seu produto</span>
        </div>
        <div>
          <CloseOutlined className='close-icon' onClick={onClose} />
        </div>
      </div>
    );
  };

  const handleConfirmationModal = () => {
    setModalConfirmation(true);
  };

  return (
    <>
      {!modalConfirmation && (
        <VertModal
          open={open}
          title={<Title />}
          className='modal-rating-container'
          onCancel={onClose}
          closeIcon={null}
        >
          <div className='modal-rating-body'>
          {(list && list.length > 1) && (
              <div>
                <Typography.Paragraph strong>
                  produto {page} de {list.length}
                </Typography.Paragraph>
              </div>
            )}
            {list[page - 1] && (
              <RatingProduct
                productImg={items[page - 1].productImg}
                productName={items[page - 1].productName}
                seller={items[page - 1].seller}
              />
            )}
            <div>
              <div className='checkbox-container'>
                <Typography.Title level={4} className='mr-small'>
                  Você já recebeu seu produto?
                </Typography.Title>
                <div className="container-checkbox-itens">
                  <div className='checkbox-item'>
                    <VertCheckbox
                      id='yes-choose'
                      title={'Sim'}
                      value={true}
                      checked={receivedProduct === true}
                      onChange={(e) => setReceivedProduct(e.target.checked)}
                    />
                    <label htmlFor="yes-choose" className='margin-x-extra-small'>
                      <Typography.Text className='checkbox-text'>
                        Sim
                      </Typography.Text>
                    </label>
                  </div>
                  <div className='checkbox-item'>
                    <VertCheckbox
                      id='no-choose'
                      title={'Não'}
                      value={false}
                      checked={receivedProduct === false}
                      onChange={(e) => setReceivedProduct(!e.target.checked)}
                    />
                    <label htmlFor="no-choose" className='margin-x-extra-small'>
                      <Typography.Text className='checkbox-text'>
                        Não
                      </Typography.Text>
                    </label>
                  </div>
                </div>
              </div>
              <div className='custom-divider' />
            </div>
            {receivedProduct && (
              <RatingForm
                orderId={items[page - 1].orderId}
                supplierId={items[page - 1].supplierId}
                productSku={items[page - 1].productSku}
                handleConfirmationModal={handleConfirmationModal}
                onCancel={() => {
                  if (page === items.length) {
                    onClose();
                    getRatingByProfile();
                    return;
                  }
                  setPage(page + 1);
                }}
              />
            )}
            {receivedProduct === false && (
              <div style={{ maxWidth: '650px', marginTop: '50px' }}>
                <VertAlert
                  type={'warning'}
                  message='*Você só poderá avaliar esse produto quando recebê-lo.'
                  closable={false}
                />
                {items && items.length > 1 && (
                  <VertButton
                    type={'highlight'}
                    size={'large'}
                    className='margin-y-small w-100'
                    onClick={() => {
                      if (items.length === page) {
                        onClose();
                        return;
                      }
                      setPage(page + 1);
                      setReceivedProduct(false);
                    }}
                  >
                    {items.length === page ? 'Finalizar avaliação' : 'Próximo item'}
                  </VertButton>
                )}
              </div>
            )}
          </div>
        </VertModal>
      )}

      {modalConfirmation && (
        <ModalConfirmRating
          onCancel={() => {
            if (page === list.length) {
              onClose();
              getRatingByProfile();
              return;
            }
            setPage(page + 1);
          }}
        />
      )}
    </>
  );
};

RatingProducts.propTypes = {
  open: PropTypes.bool,
  items: PropTypes.array,
  onCancel: PropTypes.func,
  onClose: PropTypes.func,
};

export default RatingProducts;
